import PropTypes from 'prop-types';
import useTransaction from 'Hooks/useTransaction';
import CardTransaction from 'Components/Molecules/CardTransaction/CardTransaction';
import CardTransactionSkeleton from 'Components/Molecules/CardTransaction/CardTransactionSkeleton';

export default function CardTransactionAsync(props) {
    const { transactionId, className, ...cardProps } = props;

    const { transaction, isLoading } = useTransaction(transactionId);

    if (!transactionId) return null;

    if (isLoading) {
        return <CardTransactionSkeleton className={className} />;
    }

    if (!transaction.provider_connection_product) return null;

    return <CardTransaction transaction={transaction} className={className} {...cardProps} />;
}

CardTransactionAsync.propTypes = {
    transactionId: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    onDelete: PropTypes.func,
    className: PropTypes.string,
    deleteTooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};
